import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { NgClass } from '@angular/common';
import { MenuModule } from 'primeng/menu';
import { ColorsPipe } from '@shared/filters/colors/colors.pipe';
import { FormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { CustomizeFieldsFactory } from '@shared/factories/customize-fields/customize-fields.factory';
import { cloneDeep } from 'lodash';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
// import { DragulaModule, DragulaService } from 'ng2-dragula';

@Component({
    selector: 'customize-codification-values',
    templateUrl: './customize-codification-values.component.html',
    standalone: true,
    imports: [AfTranslatePipe, NgClass, AfTranslateDirective, MenuModule, ColorsPipe, FormsModule, InputNumberModule],
    // imports: [DragulaModule]

})
export class CustomizeCodificationValuesComponent implements OnInit, OnChanges {
  customizeCodificationValues: any = {
    editingEncodingItem:{
      operator1: null,
      value1: null,
      operator2: null,
      value2: null,
      text: null,
      color: this.customizeFieldsFactory.getListValueColors()[0].color
    },
    listColors: this.customizeFieldsFactory.getListValueColors(),
    firstOperator: [
      { listValueId:'<', text:'<' },
      { listValueId:'<=', text:'<=' },
      { listValueId:'<>', text:'<>' },
      { listValueId:'=', text:'=' },
      { listValueId:'>', text:'>' },
      { listValueId:'>=', text:'>=' }
    ],
    secondOperator: [
      { listValueId: '<', text: '<' },
      { listValueId: '<=', text: '<=' },
      { listValueId: '>', text: '>' },
      { listValueId: '>=', text: '>=' }
    ],
  }

  constructor( private commonUtilsService: CommonUtilsService,
    private customizeFieldsFactory: CustomizeFieldsFactory,
    private translate: AfTranslateFactory
   ) {}

  @Input() field: any = null;
  @Input() item: any = null;
  @Input() typeView: string = 'new';
  @Output() changeEncodingValue = new EventEmitter();

  ngOnInit(){
    if(this.typeView === 'edit'){
      this.customizeCodificationValues.editingEncodingItem = cloneDeep(this.item);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  operatorSelected(operator:any, type: any, item:any){
    if(item[type] !== operator.listValueId){
      item[type] = operator.listValueId;
      item[type + 'Error'] = false;
      if(item.operator1 === '=' || item.operator1 === '<>'){
        delete item.operator2;
        delete item.value2;
      }
    }else{
      if(type === 'operator1'){
        delete item.operator1;
        delete item.value1;
        delete item.operator2;
        delete item.value2;
      }else if(type === 'operator2'){
        delete item.value2;
        delete item.operator2;
      }
    }
  }

  checkErrorValue(type: any, item:any){
    if(item[type]){
      item[type + 'Error'] = false;
    }
  }

  addEncodingValue() {
    let that: any = this.customizeCodificationValues;
    let checkErrorNewEncoding: boolean = this.checkErrorNewEncoding(that.editingEncodingItem);
    if(!checkErrorNewEncoding){
      if (that.editingEncodingItem) {
        this.commonUtilsService.setEncodingDisplayText(that.editingEncodingItem);
        if (this.typeView === 'new') {
          that.editingEncodingItem.fieldEncodingId = 0;
          that.editingEncodingItem.numOrder = this.field.fieldEncodings.length;
          this.field.fieldEncodings.push(that.editingEncodingItem);
        }else {
          this.item.operator1 = that.editingEncodingItem.operator1;
          this.item.value1 = that.editingEncodingItem.value1;
          this.item.operator2 = that.editingEncodingItem.operator2;
          this.item.value2 = that.editingEncodingItem.value2;
          this.item.text = that.editingEncodingItem.text;
          this.item.color = that.editingEncodingItem.color;
          this.item.displayText = that.editingEncodingItem.displayText;
        }
        this.closeEncodingValue();
      }
    }else{
      this.changeEncodingValue.emit({ error: true });
    }
  }

  checkErrorNewEncoding(item: any){
    let errorEncoding: boolean = false;
    if(!item.text){
      errorEncoding = true;
      item.textError = true;
    }
    if(!item.operator1){
      errorEncoding = true;
      item.operator1Error = true;
    }
    if(item.operator1 && typeof item.value1 !== 'number'){
      errorEncoding = true;
      item.value1Error = true;
    }
    if(item.operator2 && typeof item.value2 !== 'number'){
      errorEncoding = true;
      item.value2Error = true;
    }
    return errorEncoding;
  }

  closeEncodingValue(){
    if(this.typeView === 'edit'){
      this.item.showConfigurationEncoding = false;
    }
    this.changeEncodingValue.emit({error: false});
  }

  toggleFilter(e: any, menu: any){
    this.commonUtilsService.toggleFilterOverlay(e, menu, 'menu');
  }

  isNumber(value: any){
    return typeof value === 'number';
  }
}
